module.exports = __webpack_public_path__ + "media/images/payments/bitcoin-97d879928d89dd9eca9fbd5842339019.svg";